import React from "react";
import Dashboard from "../../components/shared/layout/Dashboard";
import Skeleton from "./Skeleton";

export default function FormatoView(props){
    return(
        <React.Fragment>
            <Dashboard {...props} Skeleton={Skeleton} menu_id={8}/>

        </React.Fragment>
    )
}